<template>
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.07999 5.64999V5.65636C5.64899 5.65636 5.29999 5.87929 5.29999 6.15318C5.29999 6.42706 5.64899 6.64999 6.07999 6.64999H9.06899C9.49999 6.64999 9.84999 6.42706 9.84999 6.14617C9.84999 5.87292 9.49999 5.64999 9.06899 5.64999H6.07999ZM11.7191 11.179H5.88084C5.55989 11.179 5.29999 10.9548 5.29999 10.6793C5.29999 10.4038 5.55989 10.179 5.88084 10.179H11.7191C12.0394 10.179 12.3 10.4038 12.3 10.6793C12.3 10.9548 12.0394 11.179 11.7191 11.179ZM13.92 15.7319H6.07999C5.77999 15.7572 5.48999 15.6623 5.32999 15.5041C5.16999 15.3396 5.16999 15.1308 5.32999 14.9726C5.48999 14.8081 5.77999 14.7195 6.07999 14.7385H13.92C14.319 14.7638 14.62 14.979 14.62 15.2384C14.62 15.4908 14.319 15.7066 13.92 15.7319Z" fill="#130F26"/>
        <path d="M14.191 1H5.81C2.77 1 1 2.78 1 5.83V16.16C1 19.26 2.77 21 5.81 21H14.191C17.28 21 19 19.26 19 16.16V5.83C19 2.78 17.28 1 14.191 1" stroke="black"/>
    </svg>
</template>

<script>
    export default {
        name: "ListIcon"
    }
</script>

<style scoped>

</style>